import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9StaticDatumsEdit } from "./edit";
import { A9StaticDataNew } from "./new";
import { A9StaticDatumsTable } from "./table";
export default function A9StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9StaticDatumsEdit />} />
      <Route index element={<A9StaticDatumsTable />} />
      <Route path="/new" element={<A9StaticDataNew />} />
    </Routes>
  );
}
